import React, { useEffect, useState, useContext } from "react"
import { useNavigate } from "react-router-dom"

import Header from "../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import {
  Box,
  TextField,
  InputLabel,
  Button,
  Typography,
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  Tooltip,
} from "@mui/material"
import DetalleImpresion from "../../Zonas/components/DetalleImpresion"
import Swal from "sweetalert2"
import ImprimirIcon from "../../../assets/iconos/Impresion.ico"
import BackIcon from "../../../components/BackIcon"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import { useQuery, queryClient, useQueryClient, useMutation } from "@tanstack/react-query"
import CustomAutoComplete from "../../SolicitudDeIngreso/components/CustomAutoComplete"
import CrearIcon from "../../../assets/iconos/Crear.ico"
import BuscarIcon from "../../../assets/iconos/Buscar.ico"
import CustomTooltip from "../../../components/ToolTip"
import Accordion from "@mui/material/Accordion"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import ExpandMore from "@mui/icons-material/ExpandMore"
import { InvertColorsOutlined, SelectAllSharp } from "@mui/icons-material"
import EjecutarAccionIcon from "../../../assets/iconos/EjecutarAccion.ico"
import CustomHelperDetail from "../../../components/CustomHelperDetail"
import GridAsociacion from "../components/DataGridAsosciacion"
import { GridSaveAltIcon } from "@mui/x-data-grid"
import { useDefaultDates } from "@mui/x-date-pickers/internals"
import { clip } from "html5-qrcode/esm/core"
import CustomBackdrop from "../../../components/CustomBackdrop"
import AsociacionPdf from "../components/AsociacionPdf"
const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})
const ClienteBox = styled(Box)({
  gridArea: "ClienteBox",
})
const ContactoBox = styled(Box)({
  gridArea: "ContactoBox",
})
const BodegaBox = styled(Box)({
  gridArea: "BodegaBox",
})
const ArticuloBox = styled(Box)({
  gridArea: "ArticuloBox",
})
const EmbalajeBox = styled(Box)({
  gridArea: "EmbalajeBox",
})
// Contenedor de campos de creacion
const Container = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
    "ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox"
    "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
    "ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox "
    "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox "
  `,
  gap: "8px",
  alignItems: "center",

  [theme.breakpoints.down("sm")]: {
    gridTemplateColumns: "repeat(6, 1fr)",
    gridTemplateAreas: `
      "ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox ClienteBox "
      "ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox ContactoBox"
      "BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox BodegaBox"
      "ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox ArticuloBox"
      "EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox EmbalajeBox"
    `,
  },
}))
const BuscarAsociacion = () => {
  const [expanded, setExpanded] = useState(false)
  const [searchAttempted, setSearchAttempted] = useState(false)
  const [isFirstTime, setFirstTime] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const [infoGenerada, setInfoGenerada] = useState([])
  const [bodegas, setBodegas] = useState([])
  const [contactos, setContactos] = useState([])
  const [filtros, setFiltros] = useState({
    cliente: {},
    articulo: {},
    embalaje: {},
  })
  useEffect(() => {
    console.log("filtros actuales", filtros)
    setFiltros(filtros)
  }, [filtros])

  const [asociaciones, setAsociaciones] = useState([])
  const [bodega, setBodega] = useState("")
  const [bodegaDescripcion, setBodegaDescripcion] = useState("")
  const [autoCompleteValueBodega, setAutoCompleteValueBodega] = useState("")
  const [contacto, setContacto] = useState("")
  const [agenciaDescripcion, setAgenciaDescripcion] = useState("")
  const [agencia, setAgencia] = useState("")
  const [autoCompleteValueContacto, setAutoCompleteValueContacto] = useState("")
  const handleSetFiltros = (key, value) => {
    if (filtros[key] !== value) {
      setFiltros((prev) => ({ ...prev, [key]: value }))
    }
  }
  const handleExpandAccordion = () => {
    setExpanded((prevExpanded) => !prevExpanded)
  }
  const {
    data: dataBodegas = [],
    isError: dataBodegasError,
    isFetching: isFetchingBodegas,
    isLoading: isLoadingBodegas,
    refetch: refetchGetAllBodegas,
  } = useGetAllBodegas(filtros.cliente.clicodigo)
  useEffect(() => {
    // Solo actualiza bodegas si dataBodegas tiene valores
    if (dataBodegas.length > 0) {
      setBodegas(dataBodegas)
    }
  }, [dataBodegas])
  const handleBodegaChange = (selectedValue) => {
    const [codigo, descripcion] = selectedValue.split("-")
    setBodega(codigo)
    setBodegaDescripcion(descripcion)
    setAutoCompleteValueBodega(selectedValue)
  }
  useEffect(() => {
    console.log("useEffectBodegaNombre")
    setBodega(bodega)
    setBodegaDescripcion(bodegaDescripcion)
    console.log("informacion de bodega selected", bodega, bodegaDescripcion)
  }, [bodega])
  function useGetAllBodegas(clicodigo) {
    return useQuery({
      queryKey: ["bodegaAsociacionProductosAgencias", clicodigo],
      queryFn: async () => {
        const codigoCliente = filtros.cliente.clicodigo
        console.log("codigo cliente", codigoCliente)
        const options = {
          method: "POST",
          body: JSON.stringify({ clicodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado a la api", options.body)
        const response = await fetchwrapper("/AsociacionProdAgencia/getBodegasCliente", options)
        const result = await response.json()
        console.log("datos de la api", result)
        return result.data
      },
      enabled: !!clicodigo,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  const {
    data: dataContactos = [],
    isError: dataContactosError,
    isFetching: isFetchingContactos,
    isLoading: isLoadingContactos,
    refetch: refetchGetAllContactos,
  } = useGetAllContactos(filtros.cliente.clicodigo)
  useEffect(() => {
    if (dataContactos.length > 0) {
      setBodegas(dataContactos)
    }
  }, [dataContactos])
  const handleContactoChange = (selectedValue) => {
    const [agenCod, agenDescri, contactoDescri] = selectedValue.split(",")
    setContacto(contactoDescri)
    setAgenciaDescripcion(agenDescri)
    setAgencia(agenCod)
    setAutoCompleteValueContacto(selectedValue)
  }
  useEffect(() => {
    console.log("useEffectAgencia")
    setAgencia(agencia)
    setContacto(contacto)
    setAgenciaDescripcion(agenciaDescripcion)
    console.log("cod agencia", agencia)
    console.log("descri agencia", agenciaDescripcion)
    console.log("contacto descri", contacto)
  }, [contacto])
  function useGetAllContactos(clicodigo) {
    return useQuery({
      queryKey: ["contactoAsociacionProductosAgencias", clicodigo],
      queryFn: async () => {
        const codigoCliente = filtros.cliente.clicodigo
        console.log("codigo cliente", codigoCliente)
        const options = {
          method: "POST",
          body: JSON.stringify({ clicodigo }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("json enviado a la api", options.body)
        const response = await fetchwrapper("/AsociacionProdAgencia/getContactosCliente", options)
        const result = await response.json()
        console.log("datos de la api", result)
        return result.data
      },

      enabled: !!clicodigo,
      onError: (error) => {
        console.log("Error fetching data", error)
      },
    })
  }
  function useGetAsociacionesXFiltro() {
    return useQuery({
      queryKey: ["asociacionesXFiltro"],
      queryFn: async () => {
        console.log("cliente endpoint", filtros.cliente.clicodigo)
        const options = {
          method: "POST",

          body: JSON.stringify({
            clicodigo: filtros.cliente.clicodigo,
            invcodigo: filtros.embalaje.invcodigo,
            bodcodigo: bodega,
            artcodigo: filtros.articulo.artcodigo,
            embcodigo: filtros.embalaje.embcodigo,
            agencodigo: agencia,
            condescri: contacto,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        console.log("bodey enviado", options.body)
        // send api request here
        let response = await fetchwrapper("/AsociacionProdAgencia/getAsociacionFiltro", options)
        response = await response.json()
        console.log("respuesta de la api", response)
        return response.data
      },
      refetchOnWindowFocus: false,
      refetchOnReconnect: false, // Añade esta línea para evitar refetch al reconectar
      enabled: !searchAttempted && !isFirstTime,
    })
  }

  const resetAllFilters = () => {
    setFiltros({
      cliente: {},
      articulo: {},
      embalaje: {},
    })

    setAutoCompleteValueBodega("")
    setAutoCompleteValueContacto("")
  }

  const {
    data: fetchedAsociaciones = [],
    isError: isLoadinAsociacionessError,
    isFetching: isFetchingAsociaciones,
    isLoading: isLoadingAsociaciones,
    refetch: refetchAsociaciones,
  } = useGetAsociacionesXFiltro()
  const handleSearch = () => {
    setSearchAttempted(true)
    setFirstTime(false)
    setExpanded(false)
    refetchAsociaciones()
    console.log("refetch", refetchAsociaciones)
    resetAllFilters()
    console.log("fetchedAsociaciones", fetchedAsociaciones)
  }
  useEffect(() => {
    console.log("useEffectedSearchAttemp")
    if (searchAttempted) {
      setAsociaciones(fetchedAsociaciones)
    }
  }, [searchAttempted, fetchedAsociaciones])
  useEffect(() => {
    // Verifica si la búsqueda fue intentada y los datos ya no están cargándose
    if (searchAttempted && !isLoadingAsociaciones && !isFetchingAsociaciones && !isFirstTime) {
      console.log("filtros limpioss")
      resetAllFilters()
    }
  }, [isFetchingAsociaciones, isLoadingAsociaciones, searchAttempted])
  const { mutateAsync: deleteAsociacion, isPending: isDeletingAsociacion } = useDeleteAsociacion()
  // funcion que muestra el modal de eliminacion
  const openDeleteConfirmModal = async (row) => {
    const result = await Swal.fire({
      title: "¿Está seguro que quiere eliminar esta asociacion?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    })

    if (result.isConfirmed) {
      try {
        await deleteAsociacion(row.original)
        // Actualizar el estado de bahias después de la eliminación
        setAsociaciones((prevBahias) => prevBahias.filter((b) => b.clicodigo !== row.original.clicodigo))

        Swal.fire("Eliminado!", "La asociacion ha sido eliminada.", "success")
      } catch (error) {
        Swal.fire("Error", "No se pudo eliminar la asociacion.", "error")
      }
    }
  }
  function useDeleteAsociacion() {
    const queryClient = useQueryClient()
    return useMutation({
      mutationFn: async (asociacion) => {
        const options = {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify({
            clicodigo: asociacion.clicodigo,
            invcodigo: asociacion.invcodigo,
            bodcodigo: asociacion.bodcodigo,
            artcodigo: asociacion.artcodigo,
            embcodigo: asociacion.embcodigo,
            agecodigo: asociacion.agecodigo,
            condescri: asociacion.condescri,
          }),
        }
        console.log("datos enviados para eliminar", options.body)
        console.log(`/AsociacionProdAgencia/deleteAsociacion`)
        const response = await fetchwrapper(`/AsociacionProdAgencia/eliminarAsociacion`, options)
        return response
      },
      // actualizacion optimista
      onMutate: (asociacion) => {
        queryClient.setQueryData(["Asociaciones"], (prevAsociaciones) =>
          prevAsociaciones?.filter((b) => b.clicodigo !== asociacion.clicodigo),
        )
      },
      onSettled: () => {
        // Invalidate and refetch
        queryClient.invalidateQueries(["asociacionesXFiltro"])
      },
    })
  }
  const navigate = useNavigate()
  const handleOpenModal = () => {
    setInfoGenerada(fetchedAsociaciones) // Asigna los datos de la tabla al estado
    setOpenModal(true)
  }
  const handleCloseModal = () => {
    setOpenModal(false)
    navigate("/home/dashboard/AsociacionProdAgencias/buscar")
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />

      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ paddingTop: "10px", paddingBottom: "10px" }}>
            <CustomTooltip title={"Buscar Asociacion"}>
              <Button style={{ fontSize: "0.9vw" }} onClick={handleSearch}>
                <img src={EjecutarAccionIcon} alt="Crear" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
            <Tooltip title="Imprimir">
              <Button color="primary" onClick={handleOpenModal} sx={{ marginBottom: "15px" }}>
                <img src={ImprimirIcon} alt="Imprimir" style={{ width: "30px" }} />
              </Button>
            </Tooltip>
            <DetalleImpresion
              open={openModal}
              handleClose={handleCloseModal}
              infoGenerada={fetchedAsociaciones}
              nombrePdf={"Asociación de Productos a Agencias"}
              PdfComponent={AsociacionPdf}
            />
          </div>
        </div>
        <div style={{ paddingBottom: "10px" }}>
          <CustomBackdrop isLoading={isDeletingAsociacion} />
          <Accordion expanded={expanded} onChange={handleExpandAccordion} slotProps={{ heading: { component: "h2" } }}>
            <AccordionSummary expandIcon={<ExpandMore />} aria-controls="panel1a-content" id="panel1a-header">
              <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
                Criterios de búsqueda
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Container>
                <ClienteBox>
                  <CustomHelperDetail
                    label="Cliente"
                    valueSearched={filtros.cliente?.clicodigo}
                    endpoint="/AsociacionProdAgencia/getCliente"
                    valueInputMain="clicodigo"
                    valueInputSecondary="clinombre"
                    idSearchField="clicodigo"
                    errorMsgIdSearch="Error fetching data:"
                    errorMsgFilterSearch="Error en cargar datos"
                    queryKeyModal="clienteAsociacionProdAgencia"
                    perPage={10}
                    placeholder=""
                    columnsTable={[
                      {
                        accessorKey: "ciacodigo",
                        header: "Ciacodigo",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "clicodigo",
                        header: "Código de Cliente",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "clinombre",
                        header: "Nombre del Cliente",
                        size: 250,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "cliruc",
                        header: "Número de identificación",
                        size: 150,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "clitelef1",
                        header: "Teléfono",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "clidirec",
                        header: "Dirección",
                        size: 400,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <p>{value}</p>
                        },
                      },
                      {
                        accessorKey: "clireferencia1",
                        header: "Referencia Rápida",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <p>{value}</p>
                        },
                      },
                      {
                        accessorKey: "zoncodigo",
                        header: "Zona",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "clistatus",
                        header: "Estado",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          if (value === "A") return "Activo"
                          if (value === "I") return "Inactivo"
                          return <span>{value}</span>
                        },
                      },
                    ]}
                    onHandleSelectedData={(v) => handleSetFiltros("cliente", v)}
                    sxInputMain={{
                      minWidth: "170px",
                      maxWidth: "170px",
                      marginRight: "10px",
                    }}
                    sxInputSecondary={{
                      width: "100%",
                    }}
                  />
                </ClienteBox>
                <EmbalajeBox>
                  <CustomHelperDetail
                    label="Embalaje"
                    valueSearched={filtros.embalaje?.embcodigo}
                    endpoint="/AsociacionProdAgencia/getAllEmbalajes"
                    valueInputMain="embcodigo"
                    valueInputSecondary="embdescripcion"
                    idSearchField="embcodigo"
                    errorMsgIdSearch="Error fetching data:"
                    errorMsgFilterSearch="Error en cargar datos"
                    queryKeyModal="embalajeAsociacionProdAgencia"
                    perPage={10}
                    placeholder=""
                    columnsTable={[
                      {
                        accessorKey: "ciacodigo",
                        header: "Ciacodigo",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "embcodigo",
                        header: "Código de Embalaje",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "embdescripcion",
                        header: "Descripcion",
                        size: 250,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "embmetros3",
                        header: "M3",
                        size: 150,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "embpieza",
                        header: "Pieza",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },

                      {
                        accessorKey: "embstatus",
                        header: "Estado",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          if (value === "A") return "Activo"
                          if (value === "I") return "Inactivo"
                          return <span>{value}</span>
                        },
                      },
                    ]}
                    onHandleSelectedData={(v) => handleSetFiltros("embalaje", v)}
                    sxInputMain={{
                      minWidth: "170px",
                      maxWidth: "170px",
                      marginRight: "10px",
                    }}
                    sxInputSecondary={{
                      width: "100%",
                    }}
                  />
                </EmbalajeBox>
                <ArticuloBox>
                  <CustomHelperDetail
                    label="Articulo"
                    valueSearched={filtros.articulo?.artcodigo}
                    endpoint="/AsociacionProdAgencia/getAllProductos"
                    valueInputMain="artcodigo"
                    valueInputSecondary="artdescri"
                    idSearchField="artcodigo"
                    errorMsgIdSearch="Error fetching data:"
                    errorMsgFilterSearch="Error en cargar datos"
                    queryKeyModal="articuloAsociacionProdAgencia"
                    perPage={10}
                    placeholder=""
                    columnsTable={[
                      {
                        accessorKey: "ciacodigo",
                        header: "Ciacodigo",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artcodigo",
                        header: "Código de Articulo",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artdescri",
                        header: "Descripcion",
                        size: 250,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "marcodigo",
                        header: "Codigo Marca",
                        size: 150,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "mardescri",
                        header: "Marca",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "medcodigo",
                        header: "Med Codigo",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "meddescri",
                        header: "Med descripcion",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artcantactual",
                        header: "Cantidad",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa1",
                        header: "Lista de precios 1",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa2",
                        header: "Lista de precios 2",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa3",
                        header: "Lista de precios 3",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa4",
                        header: "Lista de precios 4",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa5",
                        header: "Lista de precios 5",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "artprecventa6",
                        header: "Lista de precios 6",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          const intValue = Math.trunc(value)
                          return <span>{intValue}</span>
                        },
                      },
                      {
                        accessorKey: "lindescri",
                        header: "Linea",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "codigo2",
                        header: "Codigo 2",
                        size: 100,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          return <span>{value}</span>
                        },
                      },
                      {
                        accessorKey: "artstatus",
                        header: "Estado",
                        size: 120,
                        Cell: ({ cell }) => {
                          const value = cell.getValue()
                          if (value === "A") return "Activo"
                          if (value === "I") return "Inactivo"
                          return <span>{value}</span>
                        },
                      },
                    ]}
                    onHandleSelectedData={(v) => handleSetFiltros("articulo", v)}
                    sxInputMain={{
                      minWidth: "170px",
                      maxWidth: "170px",
                      marginRight: "10px",
                    }}
                    sxInputSecondary={{
                      width: "100%",
                    }}
                  />
                </ArticuloBox>
                <BodegaBox>
                  <InputLabel>Bodega</InputLabel>
                  <CustomAutoComplete
                    items={dataBodegas}
                    onSelect={handleBodegaChange}
                    placeholder={"Buscar Bodega"}
                    value={autoCompleteValueBodega}
                  />
                </BodegaBox>
                <ContactoBox>
                  <InputLabel>Contacto</InputLabel>
                  <CustomAutoComplete
                    items={dataContactos}
                    onSelect={handleContactoChange}
                    placeholder={"Buscar Contacto"}
                    value={autoCompleteValueContacto}
                  />
                </ContactoBox>
              </Container>
            </AccordionDetails>
          </Accordion>
        </div>
        <GridAsociacion
          fetchedInfo={asociaciones}
          isLoadingInfoError={isLoadinAsociacionessError}
          isLoadingInfo={isLoadingAsociaciones}
          isFetchingInfo={isFetchingAsociaciones}
          searchAttempted={searchAttempted}
          setAsociaciones={setAsociaciones}
          refetch={refetchAsociaciones}
          deleteFunction={openDeleteConfirmModal}
        ></GridAsociacion>
      </div>
    </ThemeProvider>
  )
}
export default BuscarAsociacion
